module.exports = __webpack_public_path__ + "assets/img/conversion.1082d729.png";